export const langOpt = [
  { value: 'zh-cn', label: "简体中文" },
  { value: 'zh-cht', label: "繁体中文" },
  { value: 'en-us', label: "English" },
  { value: 'ja-jp', label: "日文" },
  { value: 'ko-kr', label: "韩文" },
  { value: 'fr-fr', label: "法语" },
  { value: 'de-de', label: "德语" },
  { value: 'ar-ae', label: "阿拉伯文" },
  { value: 'nl-nl', label: "荷兰语" },
  { value: 'es-es', label: "西班牙语" },
  { value: 'pl-pl', label: "波兰语" },
  { value: 'ru-ru', label: "俄语" },
]

export const sysLangOpt = {
  "zh-cn": {
    // 公共部分
    "public.operate": "操作",
    "public.add": "添加",
    "public.edit": "修改",
    "public.delete": "删除",
    "public.yes": "确定",
    "public.cancel": "取消",
    "public.search": "搜索",
    "public.reset": "重置",
    "public.save": "保存",
    "public.desc": "详情",
    "public.export": "导出",
    "public.yesorno": "是否确定执行此操作？",
    "public.required": "不能为空！",
    "public.id": "ID",
    "public.account": "账号",
    "public.password": "密码",
    "public.createtime": "创建时间",
    "public.creater":"创建人",
    "public.updatetime": "修改时间",
    "public.updateer":"修改人",
    "public.copy": "复制",
    // 头部
    "header.accountMessage": "账户信息",
    "header.accountMessage.changepass": "修改密码",
    "header.accountMessage.logout": "退出登录",

    // 左侧菜单
    "menu.home": "首页",
    "menu.account": "账号管理",
    "menu.shop": "店铺管理",
    "menu.shop.shopifyshop": "shopify店铺管理",
    "menu.permission": "权限管理",
    "menu.permission.tenant": "租户列表",
    "menu.permission.role": "角色管理",
    "menu.permission.menu": "菜单管理",
    "menu.log": "日志管理",
    "menu.log.loginlog": "登录日志",
    "menu.log.operatelog": "操作日志",
    "menu.stuser": "支付通道",
    "menu.stuser.group": "通道分组",
    "menu.stuser.list": "通道列表",
    "menu.stuser.urllist": "链接列表",
    "menu.stuser.payaccount": "支付账号",
    "menu.stuser.checkout": "聚合收银台",
    "menu.stuser.channel": "通道类型",
    "menu.order": "订单信息",
    "menu.order.orderlist": "订单列表",
    "menu.order.transferorder": "代付订单",
    "menu.order.stdraftorder": "草稿订单",
    "menu.order.deduction": "扣款小项",
    "menu.order.blacklist": "黑名单列表",
    "menu.order.notsynced": "未同步订单",
    "menu.order.shipping": "物流信息",
    "menu.settlement": "结算管理",
    "menu.settlement.stuser": "通道结算",
    "menu.settlement.customer": "商户结算",
    "menu.settlement.partner": "渠道结算",
    "menu.settlement.opener": "开户结算",
    "menu.settlement.payrecord": "结算记录",
    "menu.paymentmethod": "钱包支付方式",
    // 首页
    "home.todayStatistics": "当日统计",
    "home.orderstatistics": "订单TOP统计",
    "home.filter.account": "账号",
    "home.filter.stuser": "商户通道",
    "home.filter.channel": "通道类型",
    "home.filter.payaccount": "支付账号",
    "home.filter.time": "时间",
    "home.filter.currency": "币种",
    "home.filter.searchbut": "搜索",
    "home.deduplication": "去重",
    "home.nodeduplication": "不去重",
    "home.success": "成功订单",
    "home.success.num": "数量",
    "home.success.price": "金额",
    "home.success.numrate": "成功率",
    "home.success.pricerate": "成功金额率",
    "home.fail": "失败订单",
    "home.fail.num": "数量",
    "home.fail.price": "金额",
    "home.refund": "退款订单",
    "home.refund.num": "数量",
    "home.refund.price": "金额",
    "home.refund.numrate": "退款率",
    "home.refund.pricerate": "退款金额率",
    "home.dispute": "争议订单",
    "home.dispute.num": "数量",
    "home.dispute.price": "金额",
    "home.dispute.numrate": "争议率",
    "home.dispute.pricerate": "争议金额率",
    "home.dispute.pending": "未处理争议",
    "home.dispute.pending.tip": "不受上方日期筛选影响，排除已胜诉、已取消、不处理",
    "home.dispute.handle": "快速处理",
    "home.dispute.handle.win": "胜诉",
    "home.dispute.handle.lost": "败诉",
    "home.dispute.handle.cancel": "取消争议",
    "home.dispute.handle.skip": "不处理",
    "home.dispute.handle.skip.confirm": "确认标记为不处理？该笔将退出争议中列表。",
    "home.dispute.handle.skip.success": "已标记为不处理",
    "home.dispute.push": "推送争议信息",
    "home.dispute.push.confirm": "确认将该笔争议推送到商户和预警群？",
    "home.dispute.push.success": "已推送争议信息",
    "home.customer": "商户",
    "home.customer.noreconnum": "未对账订单数",
    "home.customer.noreconprice": "未对账金额",
    "home.customer.depositnum": "押款订单数",
    "home.customer.depositprice": "押款金额",
    "home.partner": "渠道",
    "home.partner.noreconnum": "未对账订单数",
    "home.partner.noreconprice": "未对账金额",
    "home.partner.depositnum": "押款订单数",
    "home.partner.depositprice": "押款金额",
    "home.opener": "开户人",
    "home.opener.noreconnum": "未对账订单数",
    "home.opener.noreconprice": "未对账金额",
    "home.opener.depositnum": "押款订单数",
    "home.opener.depositprice": "押款金额",
    "home.margin": "保证金",
    "home.margin.nosettlementnum": "未结算保证金数",
    "home.margin.nosettlementprice": "未结算保证金金额",
    "home.margin.settlementnum": "已结算保证金数",
    "home.margin.settlementprice": "已结算保证金金额",
    "home.dayorder.barprice": "每日订单金额",
    "home.dayorder.barnum": "每日订单数",
    "home.dayorder.success.barprice": "成功订单金额",
    "home.dayorder.success.barnum": "成功订单数",
    "home.dayorder.fail.barprice": "失败订单金额",
    "home.dayorder.fail.barnum": "失败订单数",
    "home.dayorder.refund.barprice": "退款订单金额",
    "home.dayorder.refund.barnum": "退款订单数",
    "home.dayorder.dispute.barprice": "争议订单金额",
    "home.dayorder.dispute.barnum": "争议订单数",
    "home.customer.twentysort": "商户前二十排名",
    "home.stuser.twentysort": "商户通道前二十排名",
    "home.customer.ordernumrate": "商户订单数量成功率",
    "home.stuser.ordernumrate": "商户通道订单数量成功率",
    "home.customer.convrate": "商户转化率",
    "home.account.disputerate": "支付账号争议率",
    "home.currency.successrate": "货币成功流水占比",
    "home.stuser.successrate": "商户通道成功流水占比",
    "home.channel.successrate": "通道类型成功流水占比",
    "home.account.successrate": "支付账号成功流水占比",
    "home.customer.disputeordernum": "商户前二十争议订单数排名",
    "home.customer.disputeorderrate": "商户前二十争议订单率排名",
    "home.customer.disputeorderprice": "商户前二十争议金额排名",
    "home.customer.disputeorderpricerate": "商户前二十争议金额率排名",
    "home.stuser.disputeordernum": "商户通道前二十争议订单数排名",
    "home.stuser.disputeorderrate": "商户通道前二十争议订单率排名",
    "home.stuser.disputeorderprice": "商户通道前二十争议金额排名",
    "home.stuser.disputeorderpricerate": "商户通道前二十争议金额率排名",
    "home.account.disputeordernum": "支付账户前二十争议订单数排名",
    "home.account.disputeorderrate": "支付账户前二十争议订单率排名",
    "home.account.disputeorderprice": "支付账户前二十争议金额排名",
    "home.account.disputeorderpricerate": "支付账户前二十争议金额率排名",
    "home.customer.failordernum":"商户前二十失败订单数排名",
    "home.customer.failorderrate":"商户前二十失败订单率排名",
    "home.customer.failorderprice":"商户前二十失败金额排名",
    "home.customer.failorderpricerate":"商户前二十失败金额率排名",
    "home.stuser.failordernum":"商户通道前二十失败订单数排名",
    "home.stuser.failorderrate":"商户通道前二十失败订单率排名",
    "home.stuser.failorderprice":"商户通道前二十失败金额排名",
    "home.stuser.failorderpricerate":"商户通道前二十失败金额率排名",
    "home.account.failordernum":"支付账户前二十失败订单数排名",
    "home.account.failorderrate":"支付账户前二十失败订单率排名",
    "home.account.failorderprice":"支付账户前二十失败金额排名",
    "home.account.failorderpricerate":"支付账户前二十失败金额率排名",
    // 租户列表
    "tenant.tenantName":"租户名称",
    "tenant.teantWebsite":"租户域名",
    "tenant.teantLogo":"租户LOGO",
    "tenant.faviconLogo":"租户favicon",
    "tenant.add":"添加租户",
    //账号管理
    "heanuser.account":"账号",
    "heanuser.password":"随机密码",
    "heanuser.account.add":"添加账号",
    "heanuser.account.copy":"复制",
    "heanuser.account.copyTitle":"复制登录账号",
    "heanuser.account.copyName":"新账号名",
    "heanuser.account.copyNamePlaceholder":"请输入新登录账号",
    "heanuser.account.copyConfirm":"将按新账号名复制登录账号和商户通道。收银台会新建。通道里的账户名会换成新账号名。通道原绑定的其他登录账号会一并带到新通道。密码重新生成，手机号不复制。",
    "heanuser.account.copySuccess":"复制成功",
    "heanuser.role":"角色",
    "heanuser.stuser":"商户通道",
    "heanuser.language":"语言",
    "heanuser.company":"公司名称",
    "heanuser.contactre":"联系人",
    "heanuser.contactphone":"联系电话",
    "heanuser.shejiaomtfw":"媒体范围",
    "heanuser.shejiaomt":"社交媒体",
    "heanuser.paymessage":"付款信息",
    "heanuser.paymessage.category":"付款信息分类",
    "heanuser.paymessage.usdt":"USDT地址",
    "heanuser.paymessage.yunhuitong":"云汇通",
    "heanuser.paymessage.other":"其他",
    "heanuser.paymessage.updated":"付款信息上次更新",
    "heanuser.paymessage.updatedEmpty":"尚未单独更新过付款信息",
    "heanuser.paymessage.filled":"付款信息",
    "heanuser.paymessage.filled.yes":"已填写",
    "heanuser.paymessage.filled.no":"未填写",
    "heanuser.telegramChatId":"主群ChatID（付款/结算）",
    "heanuser.telegramAlertChatId":"告警群ChatID（订单异常）",
    "heanuser.telegramChatId.bound":"Telegram主群",
    "heanuser.telegramChatId.bound.yes":"已绑定",
    "heanuser.telegramChatId.bound.no":"未绑定",
    "heanuser.repassword":"重置密码",
    "heanuser.account.message":"账号信息",
    "heanuser.company.message":"公司信息",
    "heanuser.tenant":"租户",
    "heanuser.payoutcurrency":"付款币种",
    "heanuser.payrate":"结算比例",
    // shopify店铺
    "shopify.shop":"shopify店铺",
    "shopify.shop.name":"店铺名称",
    "shopify.app.name":"应用名称",
    "shopify.reqwebsite":"店铺请求域名",
    "shopify.website":"店铺域名",
    "shopify.serwebsite":"店铺服务器域名",
    "shopify.version":"Client ID(新版) / API版本(旧版)",
    "shopify.btinfo":"宝塔信息",
    "shopify.btuser":"宝塔账号",
    "shopify.btpassword":"宝塔密码",
    "shopify.facebookpix":"FaceBook像素id",
    "shopify.gaix":"谷歌GA",
    "shopify.applovin":"AppLovin",
    "shopify.reqtoken":"Client Secret(新版) / shpat Token(旧版)",
    "staccount.shopifyModeTip":"Shopify店铺通道：accountClientId=店铺域名，accessToken/keyExt1/2=Shopify凭证（勿填Antom密钥）。店内Payments可挂Stripe或Antom；Antom为钱包支持多币种，客户在Shopify结账页付款。旧Stripe Card链路不变。",
    "staccount.antomShopifyTip":"Antom+Shopify模式：payType可选antom作标签，accountType必须为shopify店铺通道，凭证仍是Shopify；店内配置Antom收款后建链走官方发票。",
    "staccount.inflywayTip":"Infly 钱包：账户大类选「钱包」，账号类型选 Infly钱包。公钥填 pk_prod_，私钥填 sk_prod_，扩展字段（1）填 merchant_id（M20…），扩展字段（2）填 siteId（缺这个会报 siteId is required）。Cash App Pay / Apple Pay / Google Pay 在「支付方式」里建（类型 Inflyway，methodValue 填 Infly 的 pay_type），再在本账号勾选。",
    "shopify.moreline":"多条换行",
    // 通道分组
    "stgroup.groupname":"分组名称",
    "stgroup.addgroup":"添加通道分组",
    // 通道列表
    "stuser.successsave":"存储成功",
    "stuser.selectall":"全选",
    "stuser.selectstuser":"请选择要绑定的通道",
    "stuser.add":"添加通道",
    "stuser.edit":"修改通道",
    "stuser.copy":"复制",
    "stuser.copyConfirm":"将复制一条相同配置的商户通道，商户名称和通道编码会追加「备份」，状态为待审核。确定复制？",
    "stuser.copySuccess":"复制成功，新通道为待审核",
    "stuser.name":"商户名称",
    "stuser.account":"账号",
    "stuser.customer":"商户通道",
    "storder.merchant":"商户",
    "stuser.shopify":"shopify店铺",
    "stuser.checkout":"收银台",
    "stuser.walletMethods":"开通支付方式",
    "stuser.walletMethodsTip":"仅展示该支付账号已开通的支付方式；点右侧已选账号切换，勾选仅作用于当前商户通道。",
    "stuser.walletMethodsAll":"全选",
    "stuser.walletMethodsPickAccount":"请先点选右侧已绑定账号，再勾选该账号的支付方式",
    "stuser.group":"通道分组",
    "stuser.channel":"通道类型",
    "stuser.channelb":"通道类型(绑)",
    "stuser.channelf":"通道类型(非)",
    "stuser.channel2":"二抛通道类型",
    "stuser.channel2b":"二抛通道类型(绑)",
    "stuser.channel2f":"二抛通道类型(非)",
    "stuser.payaccount":"支付账号",
    "stuser.accountb":"支付账号(绑)",
    "stuser.accountf":"支付账号(非)",
    "stuser.payaccount2":"二抛支付账号",
    "stuser.account2b":"二抛支付账号(绑)",
    "stuser.account2f":"二抛支付账号(非)",
    "stuser.accounttype":"支付账号类型",
    "stuser.dy":"是否订阅",
    "stuser.contract":"联系人",
    "stuser.sm":"是否显示说明",
    "stuser.shippingdt":"物流代填",
    "stuser.margin":"是否开启保证金",
    "stuser.pushmargin":"保证金比例",
    "stuser.status":"通道状态",
    "stuser.rate":"结算比例",
    "stuser.rateFormula":"1-结算比例+账户费率",
    "stuser.paycurrency":"结算货币",
    "stuser.limit":"限制订单数",
    "stuser.creatept":"建站平台",
    "stuser.sourcewebsite":"来源网站",
    "stuser.xiaofeishui":"消费税",
    "stuser.yunfeixian":"运费险",
    "stuser.message":"通道说明",
    "stuser.createurl":"创建支付连接",
    "stuser.createurln":"生成支付连接",
    "stuser.morereview":"批量审核",
    "stuser.moreclose":"批量关闭",
    "stuser.moregroup":"批量分组",
    "stuser.moreactivate":"批量激活",
    "stuser.morebindaccount":"批量绑定支付账号",
    "stuser.morebindaccount2":"批量绑定二抛支付账号",
    "stuser.apikey":"api秘钥",
    "stuser.opennew":"是否开启新版",
    "stuser.partner":"合作伙伴",
    "stuser.partnerrate":"合作伙伴结算比例",
    "stuser.partnercurrency":"合作伙伴结算货币",
    "stuser.productname":"产品名称",
    "stuser.currency":"货币",
    "stuser.totalprice":"金额",
    "stuser.language":"语言",
    "stuser.alreadyurl":"已生成支付连接",
    "stuser.email":"邮箱",
    "stuser.phone":"手机号",
    "stuser.firstname":"First Name",
    "stuser.lastname":"Last Name",
    "stuser.country":"国家",
    "stuser.province":"省份",
    "stuser.city":"城市",
    "stuser.zip":"邮编",
    "stuser.address1":"详细地址",
    // 链接列表
    "sturl.orderno":"订单号",
    "sturl.dyplan":"订阅计划",
    "sturl.producturl": "商品链接",
    "sturl.officialLink": "官方链接",
    "sturl.qrcode": "二维码",
    "sturl.linkopen": "链接是否打开",
    "sturl.linkopentime": "链接打开时间",
    "sturl.productType": "产品类型",
    "sturl.productCategory": "产品分类",
    "sturl.planname": "计划名称",
    "sturl.plandesc": "计划描述",
    "sturl.planperiod": "试用期",
    "sturl.plantriaunit": "试用期单位",
    "sturl.planTrialCount": "试用期频次",
    "sturl.plantrialtotal": "试用期总周期",
    "sturl.plantrialamount": "试用期金额",
    "sturl.plantrialcurrency": "试用期货币",
    "sturl.planregular": "常规期",
    "sturl.planRegularUnit": "常规期单位",
    "sturl.planRegularCount": "常规期频次",
    "sturl.planRegularTotal": "常规期总周期",
    "sturl.planRegularAmount": "常规期金额",
    "sturl.planRegularCurrency": "常规期货币",
    "sturl.openNewVersion": "是否收银台",
    // 支付账号
    "staccount.add":"添加支付账号",
    "staccount.copy":"复制",
    "staccount.copyConfirm":"将复制一条相同配置的支付账号，账户名称和昵称会追加「备份」。确定复制？",
    "staccount.copySuccess":"复制成功",
    "staccount.pushFiles":"推送文件",
    "staccount.pushFilesTitle":"推送 wp-checkout 文件",
    "staccount.pushFilesCommit":"最近提交",
    "staccount.pushFilesSelect":"选择要推送的文件",
    "staccount.pushFilesEmpty":"最近一次提交无 wp-checkout 文件变更",
    "staccount.pushFilesSuccess":"推送完成",
    "staccount.pushFilesConfirm":"确认推送",
    "staccount.edit":"修改支付账号",
    "staccount.status":"账号状态",
    "staccount.accountMonitor":"账户监控",
    "staccount.monitorStatus":"监控状态",
    "staccount.monitorCheckTime":"最近检测时间",
    "staccount.monitorFailReason":"监控失败原因",
    "staccount.monitorCheck":"复测",
    "staccount.monitorCheckDone":"检测完成",
    "staccount.certExpire":"证书到期",
    "staccount.nextCheck":"下次自动检测",
    "staccount.accountName":"账户名称",
    "staccount.nickName":"昵称",
    "staccount.smsKeyword":"短信关键字",
    "staccount.payType":"账户大类",
    "staccount.accountIndex":"索引",
    "staccount.accountGroup":"账号组",
    "staccount.tag":"标签",
    "staccount.tag.add":"打标签",
    "staccount.tag.placeholder":"新标签...（如 VIP / 待优化 / 高客单）",
    "staccount.tag.empty":"暂无标签",
    "staccount.tag.create":"添加",
    "staccount.tag.history":"已用标签（点击添加）：",
    "staccount.tag.historyEmpty":"暂无已用标签",
    "staccount.tag.current":"已打标签",
    "staccount.tag.hint":"输入后回车添加，点标签文字可改字，点 × 移除；保存后显示在支付账号名旁。",
    "shipping.tag":"标签",
    "shipping.tag.add":"打标签",
    "shipping.tag.placeholder":"新标签...（如 已发货 / 待补单 / 地址异常）",
    "shipping.tag.empty":"暂无标签",
    "shipping.tag.create":"添加",
    "shipping.tag.history":"已用标签（点击添加）：",
    "shipping.tag.historyEmpty":"暂无已用标签",
    "shipping.tag.hint":"输入后回车添加，点标签文字可改字，点 × 移除；保存后显示在物流信息旁。",
    "staccount.website":"网站",
    "staccount.adsUserId":"ads环境编号",
    "staccount.opener":"开户人",
    "staccount.openerPayoutRate":"开户人抽佣",
    "staccount.openerPayoutCurrency":"开户人收款货币",
    "staccount.maxTime":"当日最大次数",
    "staccount.maxAmount":"当日最大金额",
    "staccount.maxAmountOneTime":"单次最大金额",
    "staccount.createdTime":"创建时间",
    "staccount.accountRate":"账户费率",
    "staccount.accountCurrency":"账户货币类型",
    "staccount.paymentMethodId":"支付方式",
    "staccount.test":"是否测试账号",
    "staccount.accountKeySetting":"设置账户公私钥信息",
    "staccount.accountClientId":"账户accountClientId",
    "staccount.accountPublicKey":"账户公钥(accountPublicKey)",
    "staccount.accountPrivateKey":"账户私钥(accountKey)",
    "staccount.accountKey":"账户私钥(accountKey)",
    "staccount.keyExt1":"扩展字段（1）",
    "staccount.keyExt2":"扩展字段（2）",
    "staccount.keyExt3":"扩展字段（3）",
    "staccount.webhook":"Webhook地址",
    "staccount.amountLimit":"设置账户金额限制",
    "staccount.limitInfo":"金额限制",
    "staccount.quota":"可用额度",
    "staccount.quotaTitle":"激活账号可用额度",
    "staccount.quotaHint":"按近 24 小时成功单统计，规则与收银台选户一致；额度按账号全局占用。",
    "staccount.quotaAllType":"全部通道",
    "staccount.quotaFilter":"通道类型",
    "staccount.quotaActive":"激活账号",
    "staccount.quotaExhausted":"已满",
    "staccount.quotaRemainCount":"剩余笔数",
    "staccount.quotaRemainAmount":"剩余金额",
    "staccount.quotaUsedCount":"已用笔数",
    "staccount.quotaUsedAmount":"已用金额",
    "staccount.quotaNextFree":"下次腾出",
    "staccount.quotaUnlimited":"不限",
    "staccount.quotaRefresh":"刷新",
    "staccount.singleFixedCost":"单笔固定成本",
    "staccount.newVersion":"新版本标记",
    "staccount.accountMethod":"支付方式费率设置",
    // 聚合收银台
    "stcheckout.add":"添加聚合收银台",
    "stcheckout.edit":"修改聚合收银台",
    "stcheckout.checkoutName":"收银台名称",
    "stcheckout.checkoutAliasname":"收银台别名",
    "stcheckout.checkoutStatus":"收银台状态",
    "stcheckout.bindAccount":"绑定账号",
    "stcheckout.accountlist":"支付账号列表",
    "stcheckout.checkedaccountlist":"选中支付账号列表",
    "stcheckout.rateDefault":"沿用通道",
    "stcheckout.partnerrate":"伙伴比例",
    // 通道类型
    "stchannel.add":"添加通道类型",
    "stchannel.edit":"修改通道类型",
    "stchannel.bindcurrency":"绑定货币",
    "stchannel.name":"渠道名称",
    "stchannel.displayName":"渠道别名",
    "stchannel.status":"渠道状态",
    "stchannel.payType":"渠道字符",
    "stchannel.paypalEmailEnable":"邮件收款",
    "stchannel.currencyOffsetRate":"货币偏移量",
    "stchannel.info":"渠道说明",
    // 订单列表
    "storder.transactionId":"交易id",
    "storder.number":"卡号",
    "storder.name":"客户名称",
    "storder.refundStatus":"退款状态",
    "storder.refundAmount":"退款金额",
    "storder.refundTime":"退款时间",
    "storder.disputeStatus":"争议状态",
    "storder.warnStatus":"预警状态",
    "storder.warnTime":"预警时间",
    "storder.warnRemark":"预警备注",
    "storder.warnRemark.adminOnly":"仅管理员可见",
    "storder.warnRemark.placeholder":"选填，说明标记预警的原因",
    "storder.warnRemark.max":"备注不能超过500字",
    "storder.disputeSt":"争议详细状态",
    "storder.methodName":"支付方式",
    "storder.status":"支付状态",
    "storder.msg":"支付结果",
    "storder.redirectUrl":"支付跳转链接",
    "storder.refund":"退款",
    "storder.deduction":"扣款小项明细",
    "storder.disputeCreatimeTimes":"争议时间",
    "storder.searchParams":"交易/订单号",
    "storder.addblack":"添加黑名单",
    "storder.adddeduction":"添加扣款小项",
    "storder.moredispute":"批量争议",
    "storder.disputemsg":"请确定已选择要争议订单？",
    "storder.warn":"增加预警",
    "storder.warn.confirm":"确认标记为预警？该笔尚未开争议，之后仍可再开争议。",
    "storder.warn.success":"已标记为预警",
    "storder.warn.tab":"预警",
    "storder.seetexport":"结算信息导出",
    "storder.flowhourlyreport":"发送小时报",
    "storder.flowhourlyreportSuccess":"小时报已发送到 Telegram 总群",
    "storder.repushMerchantAlert":"补推",
    "storder.repushMerchantAlertConfirm":"确认将该订单异常补推到商户 Telegram？",
    "storder.repushMerchantAlertSuccess":"已补推到商户",
    "storder.dispute":"争议",
    // "storder.transactionId":"交易id",
    // "storder.transactionId":"交易id",
    // "storder.transactionId":"交易id",
    // "storder.transactionId":"交易id",
    // "storder.transactionId":"交易id",

    "paymethod.payType":"钱包类型",
    "paymethod.methodName":"支付方式名称",
    "paymethod.methodValue":"支付方式值",
    "paymethod.iconPath":"支付方式图标",
    "paymethod.iconWidth":"图标宽度",
    "paymethod.iconHeight":"图标高度",
    "paymethod.methodSort":"排序",
    "paymethod.currencyStr":"绑定货币",
    "paymethod.add":"添加支付方式",
    "paymethod.edit":"修改支付方式",
    "paymethod.bindCurrency":"绑定货币",





    





    














  }
}